import { SecurityRuleFactory, createSimpleClaimRule } from "../auth-rules";

export type SayHelloClaimType = string | string[];
export type SayHelloClaimArgs = {};

export const ruleSayHello: SecurityRuleFactory<SayHelloClaimType, SayHelloClaimArgs> =
  createSimpleClaimRule<SayHelloClaimType, SayHelloClaimArgs>("say-hello");

